import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Assinatura digital (ICP-Brasil) do documento com o certificado A1 do profissional.
export function useSignDocument() {
  const [isSigning, setSigning] = useState(false);

  const sign = useCallback((patientId, documentId, { certificatePassword }) => {
    setSigning(true);
    return quarkusApi
      .post(
        `/patients/${patientId}/documents/${documentId}/signature`,
        { certificatePassword },
        { headers: { Authorization: sessionStorage.getItem('token') } },
      )
      .finally(() => setSigning(false));
  }, []);

  return { sign, isSigning };
}
